(function () {
  if (window.__kcDtcHome) return;
  window.__kcDtcHome = true;

  var doc = document;
  var html = doc.documentElement;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  html.classList.add('kh-js');

  var data = null, P = {}, Q = [], ORDER = [], TXT = {}, ICON = {};
  var st = { step: 0, ans: {} };
  var busy = false;

  function track(name, detail) {
    detail = detail || {};
    try { doc.dispatchEvent(new CustomEvent('kh:' + name, { detail: detail })); } catch (e) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var row = { event: 'kh_' + name };
      Object.keys(detail).forEach(function (k) { row[k] = detail[k]; });
      window.dataLayer.push(row);
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function fill(s, map) {
    return String(s || '').replace(/\[([a-z]+)\]/g, function (m, k) { return map[k] == null ? m : map[k]; });
  }
  function lines(s) {
    return String(s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function pairs(s, sep) {
    var out = {};
    String(s || '').split(sep).forEach(function (row) {
      var i = row.indexOf(':');
      if (i < 1) return;
      out[row.slice(0, i).trim()] = row.slice(i + 1).trim();
    });
    return out;
  }
  function list(s) {
    return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function readData() {
    var el = doc.getElementById('kh-data');
    data = null; P = {}; Q = []; ORDER = []; TXT = {}; ICON = {};
    if (!el) return;
    try { data = JSON.parse(el.textContent); } catch (e) { data = null; }
    if (!data) return;
    P = data.products || {};
    ORDER = (data.order || []).filter(function (k) { return P[k]; });
    TXT = data.text || {};
    ICON = data.icons || {};
    Q = (data.questions || []).filter(function (q) { return q.opts && q.opts.length; }).map(function (q) {
      return {
        id: q.id, q: q.q, hint: q.hint,
        opts: q.opts.map(function (o) {
          var score = {}, raw = pairs(o.s, ',');
          Object.keys(raw).forEach(function (k) { score[k] = Number(raw[k]) || 0; });
          return { id: o.id, icon: o.icon, t: o.t, d: o.d, s: score, x: list(o.x), why: pairs(o.why, /\r?\n/) };
        })
      };
    });
  }

  function dialogs() { return $$('dialog.kh-dlg'); }
  function anyOpen() { return dialogs().some(function (d) { return d.open; }); }
  function openDlg(d, opener) {
    if (!d || d.open) return;
    d._opener = opener || null;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    html.classList.add('kh-lock');
    syncBar();
  }
  function closeDlg(d) {
    if (!d || !d.open) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
    onClose(d);
  }
  function onClose(d) {
    if (!anyOpen()) html.classList.remove('kh-lock');
    syncBar();
    if (d._opener && doc.contains(d._opener) && typeof d._opener.focus === 'function') d._opener.focus();
    d._opener = null;
  }

  function finder() { return doc.getElementById('kh-finder'); }
  function ready() { return !!(finder() && Q.length && ORDER.length); }
  function startFinder(opener, preset) {
    var fd = finder();
    st = { step: 0, ans: {} };
    if (preset && Q[0].opts.some(function (o) { return o.id === preset; })) { st.ans[Q[0].id] = preset; st.step = 1; }
    render(false);
    openDlg(fd, opener);
    focusTitle();
    track('finder_start', { from: (opener && opener.getAttribute('data-from')) || 'page' });
    if (st.step === 1) track('finder_answer', { question: Q[0].id, answer: preset });
  }
  function focusTitle() {
    var fd = finder();
    var t = $('#kh-q-title', fd);
    var bd = $('.kh-dlg__bd', fd);
    if (bd) bd.scrollTop = 0;
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }
  function render(focus) {
    var fd = finder();
    var atResult = st.step >= Q.length;
    $('[data-finder-back]', fd).hidden = st.step === 0;
    $('[data-finder-skip]', fd).hidden = atResult;
    $('[data-finder-again]', fd).hidden = !atResult;
    $('[data-finder-done]', fd).hidden = !atResult;
    if (atResult) renderResult(); else renderQuestion();
    if (focus !== false) focusTitle();
  }
  function renderQuestion() {
    var q = Q[st.step];
    var bars = Q.map(function (_, i) { return '<i' + (i <= st.step ? ' class="is-on"' : '') + '></i>'; }).join('');
    var opts = q.opts.map(function (o) {
      return '<button type="button" class="kh-opt" data-opt="' + esc(o.id) + '" aria-pressed="' + (st.ans[q.id] === o.id) + '">' +
        '<span class="kh-opt__ic">' + (o.icon || '') + '</span>' +
        '<span><span class="kh-opt__t">' + esc(o.t) + '</span><span class="kh-opt__d">' + esc(o.d) + '</span></span>' +
        (ICON.chev || '') + '</button>';
    }).join('');
    $('[data-finder-body]', finder()).innerHTML =
      '<div class="kh-prog"><span class="kh-prog__t">' + esc(fill(TXT.question, { n: st.step + 1, total: Q.length })) + '</span>' +
      '<span class="kh-prog__bar" aria-hidden="true">' + bars + '</span></div>' +
      '<div class="kh-q"><h3 id="kh-q-title" tabindex="-1">' + esc(q.q) + '</h3>' +
      (q.hint ? '<p class="kh-q__hint">' + esc(q.hint) + '</p>' : '') +
      '<div class="kh-opts" role="group" aria-labelledby="kh-q-title">' + opts + '</div></div>';
  }
  function chosen() {
    return Q.map(function (q) {
      return q.opts.filter(function (o) { return o.id === st.ans[q.id]; })[0];
    }).filter(Boolean);
  }
  function score() {
    var s = {}, ex = {};
    ORDER.forEach(function (k) { s[k] = 0; });
    chosen().forEach(function (o) {
      Object.keys(o.s).forEach(function (k) { if (k in s) s[k] += o.s[k]; });
      o.x.forEach(function (k) { ex[k] = true; });
    });
    var all = ORDER.slice().sort(function (a, b) { return (s[b] - s[a]) || (ORDER.indexOf(a) - ORDER.indexOf(b)); });
    var ok = all.filter(function (k) { return !ex[k]; });
    if (!ok.length) ok = all;
    return { pick: ok[0], alt: ok[1], dropped: ex[all[0]] && ok[0] !== all[0] ? all[0] : null, strict: Object.keys(ex).length > 0 };
  }
  function reasons(k) {
    var out = [];
    chosen().forEach(function (o) { var m = o.why[k]; if (m && out.indexOf(m) < 0) out.push(m); });
    lines(P[k].defaults).forEach(function (d) { if (out.length < 3 && out.indexOf(d) < 0) out.push(d); });
    return out.slice(0, 3);
  }
  function renderResult() {
    var r = score(), p = P[r.pick], alt = r.alt ? P[r.alt] : null;
    var why = reasons(r.pick).map(function (t) { return '<li>' + (ICON.check || '') + '<span>' + esc(t) + '</span></li>'; }).join('');
    var map = { name: esc(p.name), price: esc(p.price), autoship: esc(p.sub) };
    var can = p.variant && p.available !== false;
    $('[data-finder-body]', finder()).innerHTML =
      '<div class="kh-res">' +
      '<div class="kh-res__top">' + (p.img ? '<div class="kh-res__img"><img src="' + esc(p.img) + '" alt="' + esc(p.alt) + '" width="640" height="640"></div>' : '') +
      '<div><span class="kh-eyebrow">' + esc(TXT.match) + '</span><h3 id="kh-q-title" tabindex="-1">' + esc(p.name) + '</h3><p>' + esc(p.line) + '</p></div></div>' +
      (r.dropped && P[r.dropped].dropped ? '<p class="kh-warn">' + (ICON.info || '') + '<span>' + esc(P[r.dropped].dropped) + '</span></p>' : '') +
      (why ? '<div class="kh-why"><h4>' + esc(TXT.why) + '</h4><ul>' + why + '</ul></div>' : '') +
      (r.strict && data.testNote ? '<p class="kh-note" data-test-note>' + esc(data.testNote) + '</p>' : '') +
      (p.warn ? '<p class="kh-warn">' + (ICON.alert || '') + '<span>' + esc(p.warn) + '</span></p>' : '') +
      '<div class="kh-res__buy"><div class="kh-price"><b>' + esc(p.price) + '</b>' + (p.sub ? '<span>' + fill(esc(TXT.priceNote), map) + '</span>' : '') + '</div>' +
      (can ? '<button type="button" class="kh-btn kh-btn--buy kh-btn--block" data-add="' + esc(r.pick) + '">' + esc(TXT.add) + (p.price ? ' · ' + esc(p.price) : '') + '</button>'
        : (p.variant && TXT.soldOut ? '<p class="kh-note"><b>' + esc(TXT.soldOut) + '</b></p>' : '')) +
      '<p class="kh-warn" data-add-error role="alert" hidden>' + (ICON.alert || '') + '<span></span></p>' +
      '<div class="kh-res__added" data-added role="status" hidden><p>' + (ICON.check || '') + '<span>' + fill(esc(TXT.added), map) + '</span></p>' +
      '<a class="kh-btn kh-btn--buy kh-btn--block" href="' + esc(data.cartUrl || '/cart') + '">' + esc(TXT.cart) + '</a></div>' +
      '<a class="kh-btn kh-btn--line kh-btn--block" href="' + esc(p.url) + '">' + esc(TXT.details) + '</a>' +
      (TXT.guarantee ? '<p class="kh-note">' + fill(esc(TXT.guarantee), map) + '</p>' : '') + '</div>' +
      (alt ? '<p class="kh-res__alt">' + esc(TXT.also) + ' <a class="kh-link" href="' + esc(alt.url) + '">' + esc(alt.name) + '</a>' + (alt.altline ? ', ' + esc(alt.altline) : '') + '</p>' : '') +
      '</div>';
    track('finder_result', { product: r.pick, answers: Object.keys(st.ans).map(function (k) { return k + ':' + st.ans[k]; }).join(',') });
  }

  function refreshCart(detail) {
    fetch((data.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count], .cart-count-bubble span[aria-hidden], #kc-hdr-cart-count, .kc-hdr__cart-count, .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = false;
        });
        detail.cart = cart;
        doc.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
        doc.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
        if (typeof window.publish === 'function') { try { window.publish('cart-update', { source: 'kc-dtc-home', cartData: cart }); } catch (e) {} }
      })
      .catch(function () {});
  }
  function addToCart(btn) {
    var k = btn.getAttribute('data-add'), p = P[k];
    var body = $('[data-finder-body]', finder());
    var err = $('[data-add-error]', body);
    if (!p || busy || btn.classList.contains('is-done')) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    err.hidden = true;
    function fail(message) {
      busy = false;
      btn.removeAttribute('aria-busy');
      $('span', err).textContent = message || TXT.error || '';
      err.hidden = false;
    }
    fetch((data.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: p.variant, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { fail(res.body && (res.body.description || res.body.message)); return; }
        busy = false;
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-done');
        btn.hidden = true;
        var added = $('[data-added]', body);
        added.hidden = false;
        var go = $('a', added);
        if (go) { try { go.focus({ preventScroll: true }); } catch (e) { go.focus(); } }
        var detail = { name: p.name, id: p.variant, quantity: 1, mode: 'once', selling_plan: null, source: 'home-finder' };
        doc.dispatchEvent(new CustomEvent('kcdtc:add', { detail: detail }));
        track('add', { product: k, price: p.price, source: 'finder' });
        refreshCart(detail);
      })
      .catch(function () { fail(); });
  }

  function pagerSync(pg) {
    var snap = doc.getElementById(pg.getAttribute('data-pager'));
    if (!snap) return;
    var max = snap.scrollWidth - snap.clientWidth - 4;
    if (max > 0) snap.setAttribute('tabindex', '0'); else snap.removeAttribute('tabindex');
    $$('button', pg).forEach(function (b) {
      b.disabled = b.getAttribute('data-dir') === '-1' ? snap.scrollLeft <= 4 : snap.scrollLeft >= max;
    });
  }
  function syncPagers() { $$('[data-pager]').forEach(pagerSync); }

  function tabsOf(el) {
    var sec = el.closest('.kh');
    return { tabs: $$('[role="tab"]', sec), panels: $$('[role="tabpanel"]', sec), wrap: $('[data-closer]', sec) };
  }
  function selectTab(tab, focus) {
    var t = tabsOf(tab), k = tab.getAttribute('data-tab');
    t.tabs.forEach(function (x) {
      var on = x === tab;
      x.setAttribute('aria-selected', String(on));
      x.tabIndex = on ? 0 : -1;
      if (on && focus) x.focus();
    });
    t.panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== k; });
    if (t.wrap) t.wrap.classList.add('is-ready');
  }

  var ticking = false;
  function syncBar() {
    var bar = $('[data-bar]');
    if (!bar) return;
    var cta = $('[data-hero-cta]');
    var fin = doc.getElementById('guarantee');
    var past = cta ? cta.getBoundingClientRect().bottom < 0 : window.pageYOffset > 600;
    var atEnd = fin ? fin.getBoundingClientRect().top < window.innerHeight - 120 : false;
    var on = past && !atEnd && !anyOpen() && ready();
    bar.classList.toggle('is-on', on);
    if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; syncBar(); });
  }

  function openHashTarget() {
    var id = (location.hash || '').slice(1);
    if (!id) return;
    var el = null;
    try { el = doc.getElementById(decodeURIComponent(id)); } catch (e) {}
    if (!el || !el.closest('.kh')) return;
    var d = el.tagName === 'DETAILS' ? el : el.closest('details');
    if (d) d.open = true;
  }

  function init() {
    readData();
    dialogs().forEach(function (d) {
      if (d._kh) return;
      d._kh = true;
      d.addEventListener('close', function () { onClose(d); });
      d.addEventListener('click', function (e) { if (e.target === d) closeDlg(d); });
    });
    $$('.kh-snap').forEach(function (snap) {
      if (snap._kh) return;
      snap._kh = true;
      snap.addEventListener('scroll', syncPagers, { passive: true });
    });
    $$('.kh [data-closer]').forEach(function (wrap) {
      var sec = wrap.closest('.kh');
      var tabs = $$('[role="tab"]', sec);
      if (!tabs.length) { wrap.classList.add('is-ready'); return; }
      var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      selectTab(on, false);
    });
    $$('.kh [data-compare]').forEach(function (cmp) {
      if (cmp._kh) return;
      cmp._kh = true;
      if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) cmp.open = true;
      cmp.addEventListener('toggle', function () { if (cmp.open) track('click', { id: 'compare-open' }); });
    });
    if (!ready()) $$('.kh-tease').forEach(function (t) { t.hidden = true; });
    syncPagers();
    syncBar();
    openHashTarget();
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('.kh [data-close]'))) { closeDlg(el.closest('dialog')); return; }
    if ((el = t.closest('[data-open="finder"]'))) {
      if (ready()) { e.preventDefault(); startFinder(el); }
      return;
    }
    if ((el = t.closest('.kh [data-tease]'))) { if (ready()) startFinder(el, el.getAttribute('data-tease')); return; }
    if ((el = t.closest('#kh-finder [data-opt]'))) {
      var q = Q[st.step], id = el.getAttribute('data-opt');
      if (!q) return;
      st.ans[q.id] = id;
      track('finder_answer', { question: q.id, answer: id });
      st.step += 1;
      render();
      return;
    }
    if ((el = t.closest('#kh-finder [data-finder-back]'))) { st.step = Math.max(0, Math.min(st.step, Q.length) - 1); render(); return; }
    if ((el = t.closest('#kh-finder [data-finder-again]'))) { st = { step: 0, ans: {} }; render(); return; }
    if ((el = t.closest('#kh-finder [data-finder-skip]'))) {
      var fd = finder();
      fd._opener = null;
      closeDlg(fd);
      var target = doc.getElementById('formulas');
      if (target) target.scrollIntoView();
      track('finder_skip', {});
      return;
    }
    if ((el = t.closest('#kh-finder [data-add]'))) { addToCart(el); return; }
    if ((el = t.closest('.kh [role="tab"]'))) {
      selectTab(el, false);
      track('click', { id: 'closer-' + el.getAttribute('data-tab') });
      return;
    }
    if ((el = t.closest('.kh [data-pager] button'))) {
      var snap = doc.getElementById(el.closest('[data-pager]').getAttribute('data-pager'));
      if (!snap) return;
      var card = snap.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 12 : snap.clientWidth;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      snap.scrollBy({ left: Number(el.getAttribute('data-dir')) * step, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('.kh a[href^="#faq-"]'))) {
      var d = doc.getElementById(el.getAttribute('href').slice(1));
      if (d && d.tagName === 'DETAILS') d.open = true;
    }
    if ((el = t.closest('.kh [data-track]'))) track('click', { id: el.getAttribute('data-track') });
  });

  doc.addEventListener('keydown', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('.kh [role="tab"]') : null;
    if (!tab) return;
    var tabs = tabsOf(tab).tabs, i = tabs.indexOf(tab);
    var next = e.key === 'ArrowRight' ? tabs[(i + 1) % tabs.length]
      : e.key === 'ArrowLeft' ? tabs[(i - 1 + tabs.length) % tabs.length]
      : e.key === 'Home' ? tabs[0]
      : e.key === 'End' ? tabs[tabs.length - 1] : null;
    if (!next) return;
    e.preventDefault();
    selectTab(next, true);
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { onScroll(); syncPagers(); });
  window.addEventListener('hashchange', openHashTarget);
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('shopify:section:unload', function () { window.setTimeout(init, 0); });
  doc.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest('.kh')) return;
    if (el.getAttribute('role') === 'tabpanel') {
      var tab = doc.getElementById(el.getAttribute('aria-labelledby'));
      if (tab) selectTab(tab, false);
    }
    if (el.tagName === 'DETAILS') el.open = true;
    var snap = el.closest('.kh-snap');
    if (snap) snap.scrollLeft = el.offsetLeft - snap.offsetLeft;
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
